import { Mark } from './Mark.interface';

export class MarkModel implements Mark {
  id?: number;
  title: string;
  code: string;

  constructor(data: any) {
    this.id = data.id ? data.id : null;
    this.title = data.title ? data.title : '';
    this.code = data.code ? data.code : '';
  }
}
